import { render, staticRenderFns } from "./TermsOfSales.vue?vue&type=template&id=39dcf036&scoped=true"
import script from "./TermsOfSales.vue?vue&type=script&lang=js"
export * from "./TermsOfSales.vue?vue&type=script&lang=js"
import style0 from "./TermsOfSales.vue?vue&type=style&index=0&id=39dcf036&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dcf036",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39dcf036')) {
      api.createRecord('39dcf036', component.options)
    } else {
      api.reload('39dcf036', component.options)
    }
    module.hot.accept("./TermsOfSales.vue?vue&type=template&id=39dcf036&scoped=true", function () {
      api.rerender('39dcf036', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/default/TermsOfSales.vue"
export default component.exports